














import PhoneNumber from "@/components/phoneNumber.vue";
import messageParser from "@/utils/messageParser";
import { ChatChannel } from "@/views/modules/messaging-inbox/useChat";
import { computed, defineComponent, PropType } from "@vue/composition-api";
import { findPhoneNumbersInText } from "libphonenumber-js";

type MessagePart = PhoneMessagePart | TextMessagePart;
type PhoneMessagePart = {
    type: "phone";
    formatted: string;
    unformatted: string;
};

type TextMessagePart = {
    type: "text";
    html: string;
};

export default defineComponent({
    components: {
        PhoneNumber,
    },
    props: {
        text: {
            required: true,
            type: String,
        },
        channel: {
            type: Object as PropType<ChatChannel>,
            required: true,
        },
    },
    setup(props) {
        const parsedMessage = computed((): string =>
            messageParser(props.text, {
                platform: props.channel.platform,
                provider: props.channel.provider,
            })
        );

        const messageParts = computed<MessagePart[]>((): MessagePart[] => {
            const foundPhoneNumbers = findPhoneNumbersInText(parsedMessage.value);

            const parts: MessagePart[] = [];
            let previousEnd = 0;

            foundPhoneNumbers.forEach((foundNumber) => {
                parts.push({
                    type: "text",
                    html: parsedMessage.value.substring(previousEnd, foundNumber.startsAt),
                });

                parts.push({
                    type: "phone",
                    unformatted: parsedMessage.value.substring(foundNumber.startsAt, foundNumber.endsAt),
                    formatted: foundNumber.number.formatInternational(),
                });

                previousEnd = foundNumber.endsAt;
            });

            parts.push({
                type: "text",
                html: parsedMessage.value.substring(previousEnd, parsedMessage.value.length),
            });

            return parts;
        });

        return {
            messageParts,
        };
    },
});
